
import { Component, Vue } from 'vue-property-decorator';

import Form16ProcessHeader from "@/components/process/Form16/components/Form16ProcessHeader.vue";
import Form16StyleOfProceeding from "@/components/process/Form16/components/Form16StyleOfProceeding.vue";
import { form16StatusInfoType } from '@/types/Information/Form16';

@Component({
    components:{
        Form16ProcessHeader,        
        Form16StyleOfProceeding
    }
})
export default class FillForm16 extends Vue {

    stepsCompleted = {} as form16StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }
}
